const localePt = {
  // Error view
  UDE_CAREERS_ERROR: 'Ocorreu um erro ao obter suas carreiras',
  // Career card
  UDE_CAREER_COMPLETED: 'Carreira concluída',
};
export default localePt;
